import { helpers } from 'vuelidate/lib/validators';

const regex = new RegExp(/^(\/|http[s]?:\/\/|www[.]).*$/);

export default value => {
    return !helpers.req(value) || regex.test(value);
};
